import { z } from "zod";
// Auth schemas
export const registerSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(128),
    name: z.string().min(2).max(100),
    organizationName: z.string().min(2).max(100),
});
export const loginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const refreshTokenSchema = z.object({
    refreshToken: z.string(),
});
// Site schemas
export const createSiteSchema = z.object({
    name: z.string().min(2).max(255),
    niche: z.string().max(100).optional(),
    domain: z.string().max(255).optional(),
});
export const updateSiteSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(2).max(255).optional(),
    niche: z.string().max(100).optional(),
    domain: z.string().max(255).optional(),
    status: z.enum(["active", "paused", "building", "error"]).optional(),
});
// Pipeline schemas
export const createPipelineSchema = z.object({
    name: z.string().min(2).max(255),
    description: z.string().max(1000).optional(),
    type: z.enum(["site_deploy", "content_gen", "ad_campaign", "seo_audit", "custom"]),
    config: z.record(z.string(), z.unknown()).optional(),
    schedule: z.string().max(100).optional(), // cron expression or interval like "30m", "1h", "6h"
    agentId: z.string().max(100).optional(), // YOS agent name
    promptTemplate: z.string().max(10000).optional(), // template for Manus task
});
export const triggerExecutionSchema = z.object({
    pipelineId: z.string().uuid(),
    input: z.record(z.string(), z.unknown()).optional(),
});
// Brain task schemas
export const createBrainTaskSchema = z.object({
    command: z.string().min(1).max(10000),
    agentProfile: z.enum(["manus-1.6", "manus-1.6-lite", "manus-1.6-max"]).optional().default("manus-1.6-max"),
    fileIds: z.array(z.string()).max(10).optional(),
    connectors: z.array(z.string()).max(20).optional(),
    selectedAgent: z.string().max(100).optional(),
    selectedSkills: z.array(z.string().max(100)).max(10).optional(),
});
// Brain Shortcuts schemas
export const createFunnelSchema = z.object({
    mode: z.enum(["fast", "inspiration"]),
    niche: z.string().min(1).max(100),
    geo: z.string().min(2).max(3),
    language: z.string().min(2).max(10),
    subdomain: z.string().max(63).optional(),
    baseDomain: z.string().min(3).max(255),
    inspirationUrl: z.string().url().optional(),
    notes: z.string().max(2000).optional(),
    agentProfile: z.enum(["manus-1.6", "manus-1.6-lite", "manus-1.6-max"]).optional(),
});
export const createCreativesSchema = z.object({
    project: z.string().min(1).max(100),
    niche: z.string().min(1).max(100),
    geo: z.string().min(2).max(3),
    imageUrls: z.array(z.string().url()).max(10).optional(),
    creativeDescription: z.string().max(2000).optional(),
    referenceCopys: z.string().max(5000).optional(),
    dailyBudget: z.number().min(1).max(100000),
    currency: z.string().min(3).max(3),
    notes: z.string().max(2000).optional(),
    agentProfile: z.enum(["manus-1.6", "manus-1.6-lite", "manus-1.6-max"]).optional(),
});
// Chat schemas
export const sendMessageSchema = z.object({
    message: z.string().min(1).max(10000).optional(),
    content: z.string().min(1).max(10000).optional(),
    conversationId: z.string().uuid().optional(),
    fileIds: z.array(z.string()).max(10).optional(),
    selectedAgent: z.string().max(100).optional(),
    selectedSkills: z.array(z.string().max(100)).max(10).optional(),
}).refine((data) => data.message || data.content, {
    message: "Either message or content is required",
});
export const createConversationSchema = z.object({
    title: z.string().min(1).max(255).optional(),
});
// Pagination
export const paginationSchema = z.object({
    page: z.number().int().min(1).default(1),
    limit: z.number().int().min(1).max(100).default(20),
});
// Invite schemas
export const inviteMemberSchema = z.object({
    email: z.string().email(),
    role: z.enum(["admin", "member", "viewer"]),
});
//# sourceMappingURL=index.js.map